import Topbar from "./Topbar/Topbar";
import { useToggle } from "../hooks";
import { useEffect } from "react";
import LeftSidebar from "./LeftSidebar";
import { RootState } from "../redux/store";
import { Container } from "react-bootstrap";
import { useAppSelector } from "../redux/hooks";
import MainSection from "./SupportNav/MainSection";
import { changeBodyAttributeLeftbarMode } from "../helpers/utility/layout";
import { supportMenuItems } from "../helpers/";
type LayoutProps = {
	children: any;
};

const SupportLayout = ({ children }: LayoutProps) => {
	const [isMenuOpened, toggleMenu] = useToggle();
	const isOpen = useAppSelector((state: RootState) => state.menuToggle.isSideMenuOpen);
	useEffect(() => {
        changeBodyAttributeLeftbarMode(isOpen);
    }, [isOpen]);

	const openMenu = () => {
		toggleMenu();
		if (document.body) {
			if (isMenuOpened) {
				document.body.classList.remove("sidebar-enable");
			} else {
				document.body.classList.add("sidebar-enable");
			}
		}
	};

	return (
		<>
			<div className="wrapper">
				{/* <SideNav/> */}
				<LeftSidebar isCondensed={true} isLight={false} hideUserProfile={true} menuItems={supportMenuItems()} />
				<div className="content-page">
					<div className="content">
						{/* <TopNav/> */}
						<Topbar openLeftMenuCallBack={openMenu} pharmacyGroupMenu={false} />
						<Container fluid>
							<MainSection children={children} />
						</Container>
					</div>
				</div>
			</div>
			{/* <RightSidebar /> */}
		</>
	);
}

export default SupportLayout;